/* CPPerformance — homepage merchandising + lower trust block */
(function () {
  function norm(value) {
    return String(value || '').toLowerCase().trim().replace(/\s+/g, ' ');
  }

  function el(html) {
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  function mainHome() {
    return document.querySelector("main[data-template='index']");
  }

  function sectionByHeading(main, needle) {
    if (!main) return null;
    const heading = Array.from(main.querySelectorAll('h1,h2,h3')).find(function (node) {
      return norm(node.textContent).indexOf(norm(needle)) > -1;
    });
    return heading ? (heading.closest('.shopify-section') || heading.parentElement) : null;
  }

  function cleanupOldExtraCategories() {
    document.querySelectorAll('[data-cp-extra-categories]').forEach(function (node) {
      node.remove();
    });
  }

  function moveSierstukkenToGolfSlot() {
    const main = mainHome();
    if (!main) return;
    const tips = sectionByHeading(main, 'Tips & nieuws');
    const spotlight = main.querySelector('[data-cp-sierstukken-spotlight]');
    if (!tips || !spotlight) return;
    if (tips.previousElementSibling !== spotlight) {
      tips.insertAdjacentElement('beforebegin', spotlight);
    }
    spotlight.classList.add('cp-sierstukken-spotlight--featured-slot');
  }

  function moveGolfAfterNews() {
    const main = mainHome();
    if (!main) return;
    const tips = sectionByHeading(main, 'Tips & nieuws');
    const golf = sectionByHeading(main, 'Golf 8 GTI bodykit');
    if (!tips || !golf || tips === golf) return;

    if (tips.nextElementSibling !== golf) {
      tips.insertAdjacentElement('afterend', golf);
    }
    golf.classList.add('cp-golf-after-news');

    const heading = Array.from(golf.querySelectorAll('h2,h3')).find(function (node) {
      return norm(node.textContent).indexOf('golf 8 gti bodykit') > -1;
    });
    if (heading && !golf.querySelector('.cp-golf-eyebrow')) {
      heading.insertAdjacentElement('beforebegin', el('<span class="cp-golf-eyebrow">Golf 8 • Styling</span>'));
    }
  }

  function addNewsContext() {
    const main = mainHome();
    if (!main) return;
    const tips = sectionByHeading(main, 'Tips & nieuws');
    if (!tips || tips.querySelector('.cp-news-context')) return;
    const heading = Array.from(tips.querySelectorAll('h2,h3')).find(function (node) {
      return norm(node.textContent).indexOf('tips & nieuws') > -1;
    });
    if (!heading) return;
    heading.insertAdjacentElement('afterend', el('<p class="cp-news-context">Praktische uitleg, productnieuws en inspiratie voor jouw volgende upgrade.</p>'));
  }

  function mountOrderConfidence() {
    const main = mainHome();
    if (!main) return;
    main.querySelectorAll('[data-cp-order-confidence]').forEach(function (node) { node.remove(); });
  }

  function mountAll() {
    cleanupOldExtraCategories();
    moveSierstukkenToGolfSlot();
    moveGolfAfterNews();
    addNewsContext();
    mountOrderConfidence();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
  else mountAll();

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(mountAll, 0);
  });

  const observer = new MutationObserver(function () {
    window.clearTimeout(observer._cpMerchTimer);
    observer._cpMerchTimer = window.setTimeout(mountAll, 120);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
